import { render, staticRenderFns } from "./QualityNotificationsOverview.vue?vue&type=template&id=78cdb55f"
import script from "./QualityNotificationsOverview.vue?vue&type=script&lang=js"
export * from "./QualityNotificationsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports